export default __webpack_public_path__ + "static/media/logo-blanco-320.63ed6261.png";